import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { ValidationResultModel } from '../models/api/validation-result-model';
import { AuthenticationService } from '../services/authentication.service';
import { MessageService } from '../services/message.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly messageService: MessageService,
    private readonly authenticationService: AuthenticationService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> | any {
    return next.handle(request).pipe(
      catchError((error: any) => {
        if (error?.status) {
          switch (error.status) {
            case 400:
              if (error.error?.items) {
                const validationResult = error.error as ValidationResultModel;
                const message = validationResult.items.map(item => item.value).join('\n');

                this.messageService.openError(message);
              }
              break;
            case 403:
              this.authenticationService.logout();
              this.authenticationService.navigateToLogin();
              break;
            //case 404:
            case 405:
            case 409:
            case 500:
              this.messageService.openUnknownError();
              break;
          }
        }
        else {
          this.messageService.openUnknownError();
        }

        return throwError(() => error);
      })
    );
  }
}
